import { createAsyncThunk } from '@reduxjs/toolkit';
import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';
import { AdminApiPaths } from '../../../api/APIPaths';
import {
  IRoleDeleteVerificationData,
  ITutorRole,
  ITutorRolePermissions,
} from '.';

export interface IGetTutorRoles {
  limit?: number;
  offset?: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
  status?: 'ACTIVE' | 'INACTIVE';
}

export type TAdminCreateTutorRole = {
  name: string;
  permissions: ITutorRolePermissions;
};

export type TAdminUpdateTutorRole = {
  id: string;
  name: string;
  permissions: ITutorRolePermissions;
};

const apiDataProvider = new APIDataProvider();

export const getTutorRolesForAdmin = createAsyncThunk(
  '/admin/tutor-roles/list',
  async ({ limit, offset }: IGetTutorRoles) => {
    let path = `${AdminApiPaths.tutorRoles}`;

    if (limit) {
      path += `?limit=${limit}`;
    }

    if (offset) {
      path += `&offset=${offset}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<ITutorRole>>
    >(path);

    return response.data;
  }
);

export const adminCreateTutorRole = createAsyncThunk(
  '/admin/tutor-roles/create',
  async (data: TAdminCreateTutorRole) => {
    const path = `${AdminApiPaths.tutorRoles}`;

    const response = await apiDataProvider.post<TApiResponse<ITutorRole>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminUpdateTutorRole = createAsyncThunk(
  '/admin/tutor-roles/update',
  async (data: TAdminUpdateTutorRole) => {
    const path = `${AdminApiPaths.tutorRoles}/${data.id}`;

    const response = await apiDataProvider.put<TApiResponse<ITutorRole>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminDeleteTutorRole = createAsyncThunk(
  '/admin/tutor-roles/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.tutorRoles}/${id}`;

    const response = await apiDataProvider.delete<TApiResponse<ITutorRole>>(
      path
    );

    return response.data;
  }
);

export const adminVerifyTutorRoleDelete = createAsyncThunk(
  '/admin/tutor-roles/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.tutorRoles}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IRoleDeleteVerificationData>
    >(path);

    return response.data;
  }
);
